// removed by extract-text-webpack-plugin
module.exports = {"container":"_2FI7d","closeButton":"_2oplK"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/login-modal/login-modal.scss
// module id = 946
// module chunks = 3 4 5 6 7